<div class="flex items-center justify-center flex-col gap-3">
	<h4 class="mb-5 font-bold text-center">
		Are you sure you would like to delete the following document?
	</h4>
	<p class="text-grey-dark text-center">
		This is a permanent action and cannot be undone.
	</p>

	<div
		class="flex p-1 px-2 border-gray-200 border rounded-lg items-center justify-center w-fit"
	>
		<app-icon [icon]="ICON.FILE" class="mr-3"></app-icon>
		<p>{{ title }}</p>
	</div>
</div>
<div class="flex justify-between mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="close()">Keep</app-button>
	<app-button btn="error" (click)="removeDocument()">Delete</app-button>
</div>
